import { Issue } from '../types';
import { DateFormat } from './DateFormat';

export const severityLabel = (severity: string) =>
  severity === 'low' ? 'Низкая' : severity === 'high' ? 'Высокая' : 'Средняя';

export const formatRub = (cost?: number | null) => {
  if (cost == null || !Number.isFinite(Number(cost))) return '—';
  return `${Number(cost).toLocaleString('ru-RU', {
    maximumFractionDigits: 2,
  })} ₽`;
};

export const issueStatusLabel = (issue: Pick<Issue, 'is_resolved'>) =>
  issue.is_resolved ? 'Устранена' : 'Открыта';

export const issueDateLabel = (issue: Pick<Issue, 'issue_date' | 'created_at'>) =>
  issue.issue_date
    ? DateFormat(issue.issue_date)
    : issue.created_at
      ? DateFormat(issue.created_at)
      : '—';

export const parseIssueCost = (
  raw: string
): { ok: true; value: number } | { ok: false; error: string } => {
  const text = String(raw ?? '').trim().replace(',', '.');
  if (text === '') return { ok: true, value: 0 };
  const value = Number(text);
  if (!Number.isFinite(value) || value < 0) {
    return { ok: false, error: 'Укажите стоимость в рублях' };
  }
  return { ok: true, value };
};

export const issueCostSplitLabel = (
  split?: string | null,
  members: { id: number; name: string }[] = [],
  payerIds: number[] = []
) => {
  if (split === 'personal') {
    const payer = members.find((member) => member.id === payerIds[0]);
    return payer ? `Личная · ${payer.name}` : 'Личная';
  }
  if (split === 'manual') return 'Вручную';
  if (split === 'hours') return 'Согласно налёту';
  return 'Долевая';
};

export const isLegacyRepairSplit = (split?: string | null) =>
  split === 'manual' || split === 'hours';
